import { User } from '@apis/index'
import Button from '@components/button'
import PopupToast from '@components/custom-toast'
import Fields from '@components/fields'
import { Helper } from '@utils/index'
import authSchema from '@validations/authSchema'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthHeader from '../auth/component/authHeader'
import {
  BottomSection,
  FormContainer,
  FormInputsContainer,
  FormWrapper,
} from '../auth/style'
import { ProfileContainer, StyleFixedButton } from './style'

import BackNavigation from '@components/backNavigation'
import useWindowSize from '@hooks/useWindow'
import { FormWrapper as FormBorder } from './style'

const ChangePassword = () => {
  const [loading, setLoading] = useState(false)

  const [passwordData, setPasswordData] = useState(null)

  const navigate = useNavigate()

  const [isToastOpen, setIsToastOpen] = useState(false)

  const initialValues = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  }

  const onLogout = async () => {
    await User.logout({})
      .then((resp) => {
        if (resp) {
          Helper.removeUser()
          navigate('/')
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
        setIsToastOpen(true)
      })
  }

  const submithandler = async (values: any) => {
    setLoading(true)
    const payload = {
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    }
    await User.ChangePassword(payload)
      .then(() => {
        setIsToastOpen(true)
      })
      .catch((error) => {
        console.error('Error changing password:', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const { width } = useWindowSize()

  const mobile = width < 1024

  return (
    <>
      <BackNavigation title="Change Password" />
      <ProfileContainer>
        <FormBorder>
          <AuthHeader content="Change" tag="Password" />
          <Formik
            initialValues={initialValues}
            validationSchema={authSchema.changePasswordValidationSchema}
            onSubmit={submithandler}
          >
            {({ handleSubmit, values }) => {
              setPasswordData(values)
              return (
                <FormWrapper style={{ marginTop: '40px' }}>
                  <Form onSubmit={handleSubmit}>
                    <FormContainer>
                      <FormInputsContainer>
                        <Fields.Password
                          name="currentPassword"
                          label="Current Password"
                          placeholder="Enter your current password"
                        />
                        <Fields.Password
                          name="newPassword"
                          label="New Password"
                          placeholder="Enter your new password"
                        />
                        <Fields.Password
                          name="confirmPassword"
                          label="Confirm Password"
                          placeholder="Confirm your new password"
                        />
                      </FormInputsContainer>
                      <BottomSection>
                        {!mobile ? (
                          <Button
                            title="Save Changes"
                            type="submit"
                            bg="primary"
                            height={45}
                            styleButton="margin: 8px auto 0;"
                            loading={loading}
                          />
                        ) : (
                          <StyleFixedButton>
                            <Button
                              title="Save Changes"
                              type="submit"
                              bg="primary"
                              height={45}
                              styleButton="margin: 8px auto 0;"
                              loading={loading}
                            />
                          </StyleFixedButton>
                        )}
                      </BottomSection>
                    </FormContainer>
                  </Form>
                </FormWrapper>
              )
            }}
          </Formik>
        </FormBorder>
      </ProfileContainer>
      <PopupToast
        isOpen={isToastOpen}
        onClose={() => setIsToastOpen(false)}
        heading="Congratulations!"
        content="Your password has been changed successfully."
        buttonText="Go to Login Page"
        onClick={() => onLogout()}
      />
    </>
  )
}

export default ChangePassword
